export const TASK_TRACKER_CURRENT_USER_NOT_FOUND_API_ERROR =
  'Пользователь таск-трекера не найден.'

export const TASK_TRACKER_CURRENT_USER_NOT_FOUND_ALERT_TEXT =
  'Текущий пользователь не добавлен в тасктрекер и не может совершать операции в нем'

export const isTaskTrackerCurrentUserNotFoundError = (message: string) =>
  message.includes(TASK_TRACKER_CURRENT_USER_NOT_FOUND_API_ERROR) ||
  message.includes(TASK_TRACKER_CURRENT_USER_NOT_FOUND_ALERT_TEXT)

export const getTaskTrackerCurrentUserErrorMessage = (message: string) =>
  isTaskTrackerCurrentUserNotFoundError(message)
    ? TASK_TRACKER_CURRENT_USER_NOT_FOUND_ALERT_TEXT
    : message
